import { BookingDetailSidePanelProfile } from "PFApp/booking/parts/overview/detail_view/booking_detail/booking_detail_side_panel_context/booking_detail_side_panel_context.types";
import { ProfileBasic } from "PFApp/booking/types/row";

export const getSuspendedProfileDetails = (
  profile: ProfileBasic
): BookingDetailSidePanelProfile | undefined =>
  profile.suspendedAt
    ? {
        id: profile.id,
        firstName: profile.firstName,
        lastName: profile.lastName ?? undefined,
        suspendedAt: profile.suspendedAt,
        status: "inactive"
      }
    : undefined;
